import React from 'react';
import styled from 'styled-components';

import { Divider } from 'Components/Base';
import { get as getTheme } from 'Components/Base/constants';

const QuizDivider = styled(({ isDesktop, ...restProps }) => (
  <Divider style={{ margin: isDesktop ? '0px 32px' : '32px 0px', height: 'auto' }} {...restProps} />
))`
  border: 4px solid;
  color: ${getTheme(`colors.clear.clearGrayDark`)};
`;

export default QuizDivider;
